import { getGroupsApi, GetGroupsParams } from "../../adapters/get-groups";

export const useCompanyGroups = async ({
  companyId,
  groupId,
}: GetGroupsParams) => {
  const { groups } = await getGroupsApi({ companyId, groupId });

  return { data: groups };
};
